import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { getDOMElement } from 'utility/Check/domElement';

interface PortalProps {
    children: ReactNode;
    root: string;
}

export default function Portal({ children, root }: PortalProps) {
    const $root = getDOMElement(root);

    return $root ? createPortal(children, $root) : null;
}
